import * as React from 'reactn';
import {
    ArrayUtil,
    Route,
    ButtonComponent,
    BaseConstants,
    base,
    BaseIcon, IBaseProps, BaseColor, ComponentFactory, ComponentUtil
} from "oca-lib-web";
import { addCallback } from 'reactn';
import StripeCheckout from 'react-stripe-checkout';
//import AWSAuth from "../auth/aws/AWSAuth";
import Sidebar from "../component/Sidebar";
import AWSAuth from "../auth/aws/AWSAuth";
import Styles from "../style/Styles";
import VisualUtil from "../util/VisualUtil";

interface IState {
    componentFactory:ComponentFactory,
    projects?: Array<ProjectModel>
    //currentUser?: UserModel,
    selectedProject?: ProjectModel
    currentIndex: number
}

class AdminPage extends React.PureComponent<IBaseProps, IState> {

    //public name = createRef<TextComponent>();
    //public email = createRef<TextComponent>();
    public componentRefs = ComponentUtil.createRefs(2);

    static defaultProps = {
    };

    constructor(props: any) {
        super();

        let componentFactory = new ComponentFactory(Styles.default);

        this.state = {
            componentFactory: componentFactory,
            currentIndex: 0
        };
    }

    async componentDidMount() {
        addCallback(global => {
            this.initForm()
            return null;
        });

        this.initForm();
    }

    public async initForm() {
        if (!this.global.user) return;

        this.state.componentFactory.addDefaultBinding(this.global.dataManager, "createUser", this.global.user);

        let projects = await this.global.dataManager.get("getProjectsForAdmin");
        ArrayUtil.sort(projects, "projectName");

        this.setState({projects: projects});
    }

    // Events

    async saveButtonTapped(event:any) {
        let componentBinding = this.state.componentFactory.getDefaultBinding();
        console.log(componentBinding.item);

        await componentBinding.saveBinding();
        this.props.base.notify("User saved successfully");
        //this.updateUser();

        //this.props.base.notify("error", "error");
    };

    /*cancelButtonTapped() {
        Route.goBack(this);
    };*/

    async cancelSubscriptionTapped() {
        console.log("cancelling subscription");

        let cancelSubscriptionItem = {
            subscriptionId: this.global.user ? this.global.user.subscriptionId : BaseConstants.NULL_VALUE,
            field: "cancelSubscription"
        }

        await this.global.dataManager.perform("cancelSubscription", cancelSubscriptionItem);
        await this.updateUser("free", "null");
    }

    /*async updateSubscriptionTapped(subscription:any) {
        console.log("update subscription tapped");
    };*/

    async onTokenMonthly(token:any) {
        /*let item = {
            emailAddress: token.email,
            plan: process.env.REACT_APP_PLAN_MONTHLY,
            token: token.id,
            field: "createSubscription"
        }

        console.log(item);
        await DataAccess.createSubscription(item);*/
        this.updateSubscription(token, "monthly", process.env.REACT_APP_PLAN_MONTHLY);
    };

    async onTokenYearly(token:any) {
        this.updateSubscription(token, "yearly", process.env.REACT_APP_PLAN_MONTHLY);
    }

    async updateSubscription(token:any, planName:string, planId:string) {
        let item = {
            emailAddress: token.email,
            plan: planId,
            token: token.id,
            field: "createSubscription"
        }

        console.log(item);
        let subscription = await this.global.dataManager.save("createSubscription", item);
        console.log("subscriptionId: ");
        console.log(subscription);

        this.updateUser(planName, subscription.subscriptionId);

        /*let updatedUser:UserInputModel = {
            id: this.state.currentUser.id,
            name: this.name.current ? this.name.current.getValue() : "",
            email: this.email.current ? this.email.current.getValue() : "",
            plan: planName
        };

        await DataAccess.createUser(updatedUser);*/
    }

    async updateUser(planName?:string, subscriptionId?:string) {

        /*let updatedUser:UserInputModel = {
            id: this.state.currentUser.id,
            email: this.email.current ? this.email.current.getValue() : this.state.currentUser.email,
            plan: planName ? planName : this.state.currentUser.plan,
            subscriptionId: subscriptionId ? subscriptionId : this.state.currentUser.subscriptionId,
            createdDate: moment().format()
        };*/

        //let updatedUser = this.state.currentUser;

        //let updatedUser = this.global.user;
        //updatedUser.email = this.email.current ? this.email.current.getValue() : this.global.user.email;
        //updatedUser.plan = planName ? planName : this.global.user.plan;
        //updatedUser.subscriptionId = subscriptionId ? subscriptionId : this.global.user.subscriptionId;

        //console.log(updatedUser);
        //await DataAccess.createUser(updatedUser);
    }

    // Rows

    getSubscriptionRow(item:any) {
        console.log(this.global.user.plan)
        let name = item.label === "Monthly Subscription" ? "MONTHLY" : item.label === "Annual Subscription" ? "ANNUAL" : "";
        let description = item.label === "Monthly Subscription" ? "$1 / month" : item.label === "Annual Subscription" ? "$2 / month" : "";
        let amount = item.label === "Monthly Subscription" ? 100 : item.label === "Annual Subscription" ? 200 : 0;
        let tokenCallback = item.label === "Monthly Subscription" ? this.onTokenMonthly : item.label === "Annual Subscription" ? this.onTokenYearly : null;
        let currentPlan = item.label === "Monthly Subscription" && this.global.user && this.global.user.plan === "monthly" ? true :
            item.label === "Annual Subscription" && this.global.user && this.global.user.plan === "yearly";

        return [
            item.label,
            item.price,
            !currentPlan ? <StripeCheckout
                name={name}
                description={description}
                panelLabel="Pay"
                amount={amount}
                currency="USD"
                token={tokenCallback}
                stripeKey={process.env.REACT_APP_STRIPE_KEY}>
                <ButtonComponent primary={true} title="Change Plan"/>
            </StripeCheckout> : <div>Current Plan</div>
        ];
    }

    getProjectRow(item:ProjectModel) {
        let cf = this.state.componentFactory;
        /*let editButton = <IconButtonComponent tooltip="Edit" onTouchTap={() => {
            console.log(item);
            self.setState({selectedProject: item}, function() {
                Route.go(self, 'project/' + item.id);
            })
        }} icon={BaseIcon.ICON_EDIT} color="primary" />*/
        let editButton = cf.renderIconButton(BaseIcon.ICON_EDIT, Route.goFunction(this, 'project/' + item.id));

        return [
            item.projectName,
            editButton
        ]
    }

    // Render

    async logoutButtonTapped(e:any) {
        await AWSAuth.signOut();
    }

    /*renderProfile() {
        const cf = this.state.componentFactory;
        return cf.renderBox([
            cf.renderHeader("Profile", cf.renderButton("Save", this.saveButtonTapped.bind(this))),
            cf.renderPaper([
                cf.renderBoxPadded(cf.renderTextField("email", "Email Address", this.componentRefs[0], null, {required:true})),
                cf.renderBoxPadded(cf.renderTextField("name", "Full Name", this.componentRefs[1], null, {required:true}))
            ]),
            cf.renderBoxProps({center:true, marginTop:'20px'},
                cf.renderButton("Logout", this.logoutButtonTapped.bind(this), {isFlat:true})
            )
        ])
    }*/

    async createProjectDialogCallback() {
        let projects = await this.global.dataManager.get("getProjectsForCurrentUser");
        ArrayUtil.sort(projects, "projectName");

        this.setState({selectedProject:null, projects: projects});
    }

    /*onDeleteProject() {
        console.log("delete");
    }

    onAddProject() { Route.go(this, 'project'); }*/

    onProjectSelected(event:any, item:any) {
        console.log(event);
        console.log(item);
        Route.go(this, 'project/' + item.id);
    }

    renderApps() {
        let cf = this.state.componentFactory;
        let headers = ["Project Name", ""];

        return cf.renderTableWithSelection(headers, this.state.projects, this.getProjectRow.bind(this), this.onProjectSelected.bind(this));
    }

    renderSubscription() {
        let cf = this.state.componentFactory;
        var subscriptions = [
            {id: "monthly", label: "Monthly Subscription", price: "$11.99 / 4 weeks"},
            {id: "yearly", label: "Annual Subscription", price: "$99.00 / year"}
        ];
        //let paperStyle = {paddingTop: '50px', marginLeft: '10%', marginRight: '5%'}
        let headers = ["Plan", "Price", ""];

        return cf.renderPaper(cf.renderTable(headers, subscriptions, this.getSubscriptionRow.bind(this)));
        /*return <div>
                    <div>
                        <TableComponent headers={headers}
                                        uniqueId="id"
                                        rows={subscriptions}
                                        getRow={this.getSubscriptionRow.bind(this)}/>
                    </div>

                <div className="center-input" style={{marginTop:'10px'}}>
                    <ButtonComponent style={Style.defaultButtonStyle()} secondary={true} isFlat={true} title="Cancel Subscription"
                                     onTouchTap={this.cancelSubscriptionTapped.bind(this)}/>
                </div>
            </div>*/
    }

    /*renderSidebar() {
        //var self = this;
        const cf = this.state.componentFactory;
        return (
            cf.renderPaper(
                cf.renderList(["Profile", "Projects", "Subscription"], (index:number) => { this.setState({currentIndex: index}) })
            )
        )
    }*/

    render() {
        let cf = this.state.componentFactory;
        return cf.renderBoxProps({fullHeight:true, background:BaseColor.WHITE},
            cf.renderBoxProps({marginLeft:'70px'}, [
                VisualUtil.getHeaderDisplay("Projects"),
                this.renderApps()
            ])
        )
    }
}

export default base(AdminPage, Sidebar)